<template>
    <div class="loginMenu" :class="{registering:isRegistering}">
        <div class="container">
            <input type="button" value="" @click="back" class="prevBtn">
            <div class="sun"></div>
            <div class="leaves"></div>
            <div class="prompt">
                <div v-if="isRegistering">
                    Would you like us to create<br>an account for you?
                    <div class="description">We’ll save your data for next time.</div>
                </div>
                <div v-else>
                    Hey there, let’s get you logged&nbsp;in.
                </div>
            </div>
            <div class="formContainer">
                <div class="label" :class="{ 'warning': errors.first('email') }">Your email</div>
                <input type="email" @focus="setKeyboardTarget" name="email" v-validate="'required'" v-model="email" placeholder="My@email.com" autocomplete="new-password" autofocus :readonly="$isBooth"><br>
                <div class="label" :class="{ 'warning': errors.first('password') }">Create a Password (At least 6 characters)</div>
                <input type="password" @focus="setKeyboardTarget" name="password" v-validate="'required'" v-model="password" placeholder="Password" autocomplete="new-password" :readonly="$isBooth"><br>
            </div>
            <transition name="fade" mode="out-in">
            <keyboard v-if="keyboardTarget" class="keyboard" @delete="backspace" @input="typed" :layouts="keyboardKeys"></keyboard>
            </transition>
            <div class="loginForgot">
                <div v-if="isRegistering">
                    <div class="buttonDuo">
                        <input type="button" value="NO THANKS!" @click="skip" class="skipBtn">
                        <input type="button" value="SIGN ME UP!" @click="register" class="registerBtn">
                    </div>
                    <!-- <a href="#login" class="btn stdBtn" @click.prevent="register">REGISTER</a> -->
                </div>
                <div v-else>
                    <div class="buttonDuo">
                        <a href="#login" class="btn stdBtn" @click.prevent="login">LETS GET STARTED</a>
                        <a href="#login" class="link" @click.prevent="remindPassword">I forgot my password</a>
                    </div>
                </div>
            </div>
            <div class="errorMessage">
                {{error}}
            </div>
        </div>
    </div>
</template>

<script>
import auth from '@/auth'
import Keyboard from 'vue-keyboard'
import $ from 'jquery'

export default {
    name: 'LoginPage',
    props: ['registration'],
    mixins: [],
    data() {
        return {
            emailWarn: false,
            passwordWarn: false,
            email: "",
            password: "",
            error: null,
            keyboardTarget: null,
        }
    },

    components: {
        Keyboard
    },

    methods: {
        back() {
            if (!this.registration) {
                this.$router.replace('/')
            } else {
                this.$router.replace('/report')
            }
        },
        register() {
            this.$validator.validateAll().then((result) => {
                this.$sound('chime')
                auth.upgradeAnonymousUser(this.email, this.password).then((res) => {
                    console.log("Anonymous account successfully upgraded", res.user);
                    this.$router.replace('/logout')
                }).catch((err) => {
                    console.log("Error upgrading anonymous account", err)
                    this.error = err.message
                })
            })
        },
        skip() {
            this.$router.replace('/logout')
        },
        login() {
            this.$sound('type')
            this.$validator.validateAll().then((result) => {
                if (result) {
                    auth.loginWithEmailPassword(this.email, this.password).then((res) => {
                        this.$router.replace('/form')
                    }).catch((err) => {
                        this.error = err.message
                    })
                }
            })
        },
        remindPassword() {
            console.log('Trigger password reminder')
        },
        linkToExisting() {
            console.log('Link data to existing login')
        },
        setKeyboardTarget(event) {
            this.keyboardTarget = event.srcElement.name
        },
        typed(val) {
            this.$sound('type')
            let str
            if (val == null || val == "") {
                str = ''
            } else {
                str = this[this.keyboardTarget]
                str += val
            }
            this[this.keyboardTarget] = str
        },
        backspace() {
            this.$sound('delete')
            let str = this[this.keyboardTarget]
            str = str.substring(0, str.length - 1);
            this[this.keyboardTarget] = str
        },
    },

    computed: {
        hasErrors() {
            return !this.email || !this.password
        },
        isRegistering() {
            if (!this.registration) {
                return false
            }
            // return true
            // If on this page and user is Anonymous, it's registration
            let user = auth.currentUser()
            if (auth.isAuth() && (!user.email)) {
                console.log("UID: "+user.uid)
                console.log("NEEDS REGISTRATION")
                return true
            }
            console.log("LOGGING IN")
            return false
        },
        keyboardKeys() {
            return [
                '1234567890{delete:delete}|qwertyuiop|asdfghjkl|{shift:goto:1}zxcvbnm@.|{space:space}',
                '!@#$%^&*(){delete:delete}|QWERTYUIOP|ASDFGHJKL|{shift:goto:0}ZXCVBNM,.|{space:space}'
            ]
        }
    },

    watch: {
    },

    created() {
    },

    destroyed() {
    },

    mounted() {
    }

}
</script>

<style lang="scss">
@import "../styles/variables.scss";
.loginMenu {
    background-color: $color-cream;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 8vw;
    padding-top: 30vw;
    overflow: hidden;
    .errorMessage {
        text-align: center;
        font-size: 3vw;
        margin-top: 3vw;
        width: 80vw;
        margin-left: auto;
        margin-right: auto;
        color: $color-red;
    }
    .sun {
        position: absolute;
        top: -20vw;
        right: -20vw;
        width: 40vw;
        height: 40vw;
        background-image: url(../assets/static/sun.svg);
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
        animation:spin 180s linear infinite;
    }
    .leaves {
        position: absolute;
        bottom: -8vw;
        left: -20vw;
        width: 60vw;
        height: 60vw;
        background-image: url(../assets/static/leaves.svg);
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
    }
    .keyboard {
        position: relative;
        button.vue-keyboard-key {
            background: $color-darkCream;
            color: $color-dark;
            &[data-text="shift"] {
                background: $color-darkerCream;
            }
        }
    }
    input {
        padding: 0;
        width: 94%;
        padding: 3vw 3%;
        border-radius: 1vw;
        background-color: $color-white;
    }
    input.prevBtn {
        position: absolute;
        top: 8vw;
        left: 8vw;
        height: 10vw;
        width: 10vw;
        border-radius: 5vw;
        background-color: $color-darkCream;
        background-image: url(../assets/static/BackArrow.svg);
        background-repeat: no-repeat;
        background-position: 50% 50%;
        background-size: 40%;
    }
    input:-webkit-autofill {
        animation-name: autofill;
        animation-fill-mode: both;
    }
    .helperText {
        text-align: center;
        margin-top: -4vw;
    }
    .helperText a {
        color: $color-dark;
        opacity: .5;
        font-size: 3.5vw;
        text-decoration: underline;
    }

    .container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        .prompt {
            width: 100%;
            text-align: center;
            color: $color-dark;
            .description {
                margin-top: 1vw;
                font-size: 4vw;
                color: $color-darkerCream;
                font-weight: 500;
            }
        }
        .formContainer {
            padding: 0 7vw;
            margin-top: 5vw;
            margin-bottom: 5vw;
            // width: 100%;
            .label {
                font-family: "Walsheim";
                text-transform: uppercase;
                color: $color-dark;
                font-size: 2.2vw;
                letter-spacing: .2vw;
                font-weight: 600;
                opacity: .75;
            }
        }
        .loginForgot {
            text-align: center;
            a.btn {
                display: inline-block;
                width: 60%;
            }
        }
    }
    &.registering {
        background-color: $color-cream;
        color: $color-dark;
        .prompt {
            color: $color-dark;
        }
        .formContainer .label {
            color: $color-dark;
        }
        .helperText a {
            text-align: center;
            opacity: 1;
            color: $color-darkerCream;
        }
        
    }
    .buttonDuo {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 5vw;
        text-align: center;
        input {
            display: inline-block;
            height: 10vw;
            font-weight: 700;
            font-size: 28px;
            letter-spacing: .2vw;
            line-height: 4vw;
            text-transform: uppercase;
            width: 41vw;
            border-radius: 5vw;
            margin: 2vw;
            color: $color-dark;
            background: $color-darkCream;
            &[value="SIGN ME UP!"] {
                background-color: $color-dark;
                color: $color-white;
            }
        }
    }
}
.warning {
    color: $color-red;
}

</style>